/* Экран входа: слева панель с названием и лицевой панелью коммутатора,
   справа форма. В светлой теме панель светлая, в тёмной — тёмно-синяя
   (переменные --hero-* в styles/tokens.css). */

.screen {
  display: grid;
  grid-template-columns: minmax(0, 1.3fr) minmax(380px, 1fr);
  height: 100%;
  /* У body прокрутка отключена — на низких экранах прокручивается сам экран */
  overflow-y: auto;
  background: var(--bg);
}

/* ── Панель ── */

.panel {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 56px;
  padding: 64px clamp(32px, 6vw, 88px);
  color: var(--hero-strong);
  background: var(--hero-bg);
  border-right: 1px solid var(--hero-border);
}

.brand {
  max-width: 520px;
}

.mark {
  display: block;
  margin: 0 0 20px -3px;
  color: var(--text);
}

.title {
  margin: 0;
  font-size: 46px;
  font-weight: 650;
  line-height: 1.08;
  letter-spacing: -0.015em;
}

.lead {
  text-wrap: pretty;
  max-width: 32ch;
  margin: 16px 0 0;
  font-size: 17px;
  line-height: 1.5;
  color: var(--hero-text);
}

/* Панель коммутатора — главный образ экрана. Правым ухом она упирается
   в край колонки с формой, как прикрученная к стойке. */
.device {
  width: calc(100% + clamp(32px, 6vw, 88px));
  margin-right: calc(-1 * clamp(32px, 6vw, 88px));
}

/* ── Колонка с формой ── */

.side {
  display: flex;
  align-items: center;
  padding: 48px clamp(24px, 5vw, 72px);
}

/* ── Узкие экраны: панель сверху, форма под ней ── */

@media (max-width: 860px) {
  .screen {
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;
  }

  .panel {
    border-right: none;
    border-bottom: 1px solid var(--hero-border);
    gap: 24px;
    padding: 32px 20px 28px;
  }

  .device {
    width: 100%;
    margin-right: 0;
  }

  .mark {
    width: 44px;
    height: 44px;
    margin-bottom: 16px;
  }
  .title {
    font-size: 32px;
  }
  .lead {
    margin-top: 10px;
    font-size: 15px;
  }

  .side {
    align-items: flex-start;
    padding: 32px 20px 48px;
  }
}
